import { useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Site-wide AI assistant bubble — a grounded bot that answers questions about the site
// (services, pricing, pages, getting started). Reuses the hosted bot page in embed mode
// so grounding + lead capture are identical to the client product.
// Hidden on the assessment page (/start), which has its own embedded assessment concierge.
export default function ConciergeWidget() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  if (location.pathname === "/start") return null;

  return (
    <>
      {!open && (
        <button onClick={() => setOpen(true)} data-testid="site-bot-fab" aria-label="Chat with our AI assistant"
          className="fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-gold text-navy font-semibold shadow-2xl shadow-black/40 hover:bg-gold-light transition-colors rounded-full pl-4 pr-5 py-3.5">
          <MessageCircle size={18} /> <span className="hidden sm:inline">Chat with us</span>
        </button>
      )}

      <AnimatePresence>
        {open && (
          <motion.div key="site-bot" initial={{ opacity: 0, scale: 0.97, y: 16 }} animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.97, y: 16 }} transition={{ type: "tween", duration: 0.22 }}
            className="fixed z-[60] bottom-0 right-0 md:bottom-5 md:right-5 w-full h-full md:w-[390px] md:h-[600px] md:max-h-[calc(100vh-40px)]"
            data-testid="site-bot-panel">
            <div className="relative w-full h-full bg-white md:rounded-2xl overflow-hidden shadow-2xl shadow-black/50 flex flex-col">
              <button onClick={() => setOpen(false)} data-testid="site-bot-close" aria-label="Close chat"
                className="absolute top-2.5 right-2.5 z-10 w-8 h-8 rounded-full bg-black/20 hover:bg-black/35 text-white flex items-center justify-center transition-colors">
                <X size={17} />
              </button>
              <iframe src={`${BACKEND}/bot/site?embed=1`} title="ATF WebWorks Assistant"
                className="w-full flex-1" style={{ border: "none" }} />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
